export function getText(payment) {
  return `with other payment method${payment.payment_type ? ` (${payment.payment_type_record.name})` : ''}`
}
